import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "User management", -1)
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Application access ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Assign a role to this user for this application", -1)
const _hoisted_12 = { class: "text-capitalize" }
const _hoisted_13 = { class: "text-capitalize" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled" }, "In a hybrid application, individual applications can be toggled on or off. By default, all applications are toggled on.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled" }, "This application does not have any roles", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Configure application attributes for this user", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Assign a role to this user for this application", -1)
const _hoisted_20 = { class: "text-capitalize" }
const _hoisted_21 = { class: "text-capitalize" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled" }, "In a hybrid application, individual applications can be toggled on or off. By default, all applications are toggled on.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Configure application attributes for this user", -1)
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              width: "500",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetDialog()))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "160",
                                  variant: "tonal",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-account-plus",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Add user' : 'Add'), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { title: "Add a user" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_form, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  md: "6"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "comfortable",
                                                      label: "First name",
                                                      modelValue: _ctx.user.first_name,
                                                      "onUpdate:modelValue": [
                                                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.first_name) = $event)),
                                                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                      ]
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  md: "6"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "comfortable",
                                                      label: "Last name",
                                                      modelValue: _ctx.user.last_name,
                                                      "onUpdate:modelValue": [
                                                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.last_name) = $event)),
                                                        _cache[3] || (_cache[3] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                      ]
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "comfortable",
                                                      label: "Email",
                                                      modelValue: _ctx.user.email,
                                                      "onUpdate:modelValue": [
                                                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event)),
                                                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                      ],
                                                      type: "email"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_select, {
                                                      "hide-details": "",
                                                      density: "comfortable",
                                                      label: "Role",
                                                      items: _ctx.roles,
                                                      "item-title": "name",
                                                      "item-value": "id",
                                                      modelValue: _ctx.user.role,
                                                      "onUpdate:modelValue": [
                                                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.role) = $event)),
                                                        _cache[7] || (_cache[7] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                      ]
                                                    }, null, 8, ["items", "modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: !_ctx.user.first_name || !_ctx.user.last_name || !_ctx.user.email || !_ctx.user.role || _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.addUser(); isActive.value = false;}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Add user ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              size: "small",
                              width: "160",
                              variant: "tonal",
                              disabled: !_ctx.selectedUsers.length,
                              color: "primary",
                              onClick: _ctx.removeUser
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-account-remove",
                                  start: ""
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Remove user' : 'Remove'), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "hide-details": "",
                      density: "compact",
                      placeholder: "Search users",
                      "append-inner-icon": "mdi-magnify",
                      modelValue: _ctx.searchNames,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchNames) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      items: _ctx.users,
      headers: _ctx.headers,
      modelValue: _ctx.selectedUsers,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedUsers) = $event)),
      "fixed-header": "",
      "show-select": "",
      "return-object": "",
      height: "calc(100vh - 180px)",
      "onUpdate:sortBy": _ctx.updateTableOptions,
      "items-per-page": "25"
    }, {
      [`item.avatar`]: _withCtx(({ item }) => [
        _createVNode(_component_v_avatar, { color: "secondary" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.initials(item.first_name, item.last_name)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.full_name`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.fullName(item.first_name, item.last_name)), 1)
      ]),
      [`item.role`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.roles.map((r) => r.id).includes(1) ? 'Manager' : item.roles.map((r) => r.id).includes(2) ? 'User' : 'Unknown'), 1)
      ]),
      [`item.status`]: _withCtx(({ item }) => [
        (item.status === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.status === 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "grey"
              }),
              _createTextVNode(" Pending ")
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.applications`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications, (app) => {
            return (_openBlock(), _createBlock(_component_v_tooltip, {
              key: app.id,
              location: "bottom",
              "open-delay": "200"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_avatar, _mergeProps(props, {
                  size: "32",
                  color: "secondary",
                  rounded: "",
                  class: "mx-1"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(app.name.charAt(0)), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                (app.type !=='hybrid')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(app.name), 1))
                  : (app.type === 'hybrid' && _ctx.getHybridAppsForUser(item, app.details.applications).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(app.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Applications in this hybrid app:")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHybridAppsForUser(item, app.details.applications), (subApp) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            "no-gutters": "",
                            key: subApp.applicationId
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-circle-small")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(subApp.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, " This user has no application access within the hybrid application "))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          size: "small",
          variant: "tonal",
          color: "primary",
          width: "80",
          onClick: ($event: any) => (_ctx.editUser(item)),
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 2
        }, 1032, ["onClick", "loading"])
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue", "onUpdate:sortBy"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": [
        _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editDialog) = $event)),
        _cache[21] || (_cache[21] = ($event: any) => {_ctx.applicationsToAdd = []; _ctx.newApps = []; _ctx.tab = 'details'; _ctx.appConfigDirtied = false;})
      ],
      id: "edit-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Edit user" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "details" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Details")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "config" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Configuration")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tab) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "details" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { align: "center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "pb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Name",
                                      "hide-details": "",
                                      density: "comfortable",
                                      readonly: "",
                                      "model-value": _ctx.fullName(_ctx.currentUser.first_name, _ctx.currentUser.last_name)
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "pb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Email",
                                      "hide-details": "",
                                      density: "comfortable",
                                      readonly: "",
                                      "model-value": _ctx.currentUser.email,
                                      type: "email"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => {_ctx.appConfigDirtied = true; _ctx.selectedRole = $event}),
                                      "hide-details": "",
                                      density: "comfortable",
                                      label: "Role",
                                      items: _ctx.roles,
                                      "item-title": "name",
                                      "item-value": "id",
                                      "return-object": "",
                                      "model-value": _ctx.selectedRole
                                    }, null, 8, ["items", "model-value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "config" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          justify: "space-between"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  color: "primary",
                                  variant: "plain",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.addApplicationRow(_ctx.currentUser); _ctx.appConfigDirtied = true;})
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      start: "",
                                      icon: "mdi-plus-circle"
                                    }),
                                    _createTextVNode(" Add ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentUser.applications, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list, {
                                    key: app.name
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.currentUser && _ctx.currentUser.applications?.length && _ctx.currentUser.applications.every((app) => app.id))
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 0,
                                            rounded: "",
                                            class: "pa-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panels, {
                                                "onUpdate:modelValue": ($event: any) => {_ctx.mapConfig(app);}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_expansion_panel, { "bg-color": "rgba(0,0,0,0.05)" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_expansion_panel_title, {
                                                        class: "py-0 px-2",
                                                        static: "",
                                                        "hide-actions": ""
                                                      }, {
                                                        default: _withCtx(({ collapseIcon, expandIcon, expanded }) => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            justify: "space-between",
                                                            align: "center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, { cols: "1" }, {
                                                                default: _withCtx(() => [
                                                                  expanded
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                                        _createVNode(_component_v_icon, null, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(collapseIcon), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                                        _createVNode(_component_v_icon, null, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(expandIcon), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]))
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { cols: "10" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(app.name), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_list_item_subtitle, null, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(app.description), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { cols: "1" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_action, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_btn, {
                                                                        onClick: _withModifiers(($event: any) => (_ctx.showRemoveDialog[app.id] = true), ["stop"]),
                                                                        icon: "",
                                                                        variant: "plain",
                                                                        color: "primary",
                                                                        size: "small"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, {
                                                                            icon: "mdi-delete",
                                                                            size: "large"
                                                                          })
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_expansion_panel_text, { class: "mt-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, null, {
                                                            default: _withCtx(() => [
                                                              (_ctx.getApplicationRoles(app).length && app.type !== 'hybrid')
                                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                                    key: 0,
                                                                    cols: "12"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _hoisted_11,
                                                                      _createVNode(_component_v_row, null, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_select, {
                                                                            class: "mx-2",
                                                                            label: "Application role",
                                                                            items: _ctx.getApplicationRoles(app),
                                                                            modelValue: _ctx.selectedAppRole[app.id],
                                                                            "onUpdate:modelValue": [($event: any) => ((_ctx.selectedAppRole[app.id]) = $event), ($event: any) => {_ctx.appConfigDirtied = true; _ctx.applicationRoleForUser[app.id] = _ctx.selectedAppRole[app.id].id; _ctx.applicationRoleContextForUser[app.id] = null; _ctx.selectedAppRoleContext[app.id] = {}; _ctx.getRoleLookupData(app, _ctx.applicationRoleForUser[app.id]);}],
                                                                            density: "comfortable",
                                                                            "hide-details": "",
                                                                            "item-props": _ctx.roleProps
                                                                          }, {
                                                                            selection: _withCtx(({ item }) => [
                                                                              _createElementVNode("span", _hoisted_12, _toDisplayString(item.value.name), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["items", "modelValue", "onUpdate:modelValue", "item-props"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024),
                                                                      (_ctx.applicationRolesLookupData[app.id]?.[_ctx.applicationRoleForUser[app.id]])
                                                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_select, {
                                                                                class: "mx-2",
                                                                                label: _ctx.applicationRolesLookupData[app.id][_ctx.applicationRoleForUser[app.id]].label,
                                                                                items: _ctx.applicationRolesLookupData[app.id][_ctx.applicationRoleForUser[app.id]].items,
                                                                                modelValue: _ctx.selectedAppRoleContext[app.id],
                                                                                "onUpdate:modelValue": [($event: any) => ((_ctx.selectedAppRoleContext[app.id]) = $event), ($event: any) => {_ctx.appConfigDirtied = true; _ctx.applicationRoleContextForUser[app.id] = _ctx.selectedAppRoleContext[app.id].id;}],
                                                                                density: "comfortable",
                                                                                "hide-details": "",
                                                                                "item-props": _ctx.roleContextProps,
                                                                                loading: _ctx.roleLookupDataLoading
                                                                              }, {
                                                                                selection: _withCtx(({ item }) => [
                                                                                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.value.name), 1)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1032, ["label", "items", "modelValue", "onUpdate:modelValue", "item-props", "loading"])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                        : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : (app.type === 'hybrid')
                                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                                      key: 1,
                                                                      cols: "12"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_row, null, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                                              default: _withCtx(() => [
                                                                                _hoisted_14
                                                                              ]),
                                                                              _: 1
                                                                            }),
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((app as any).subApplications, (ha) => {
                                                                              return (_openBlock(), _createBlock(_component_v_col, {
                                                                                cols: "12",
                                                                                key: ha.id
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_row, {
                                                                                    "no-gutters": "",
                                                                                    justify: "space-between",
                                                                                    align: "center"
                                                                                  }, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_v_col, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                                            default: _withCtx(() => [
                                                                                              _createTextVNode(_toDisplayString(_ctx.currentApplication?.details?.applications?.find((a) => a.applicationId === ha.id)?.tabName || ha.name), 1)
                                                                                            ]),
                                                                                            _: 2
                                                                                          }, 1024),
                                                                                          _createVNode(_component_v_list_item_subtitle, null, {
                                                                                            default: _withCtx(() => [
                                                                                              _createTextVNode("Enabled for this user " + _toDisplayString(ha.id), 1)
                                                                                            ]),
                                                                                            _: 2
                                                                                          }, 1024)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024),
                                                                                      _createVNode(_component_v_col, { cols: "2" }, {
                                                                                        default: _withCtx(() => [
                                                                                          ha
                                                                                            ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                                key: 0,
                                                                                                "hide-details": "",
                                                                                                density: "compact",
                                                                                                modelValue: ha.enabled,
                                                                                                "onUpdate:modelValue": [
                                                                                                  ($event: any) => ((ha.enabled) = $event),
                                                                                                  _cache[14] || (_cache[14] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                                ],
                                                                                                color: "primary"
                                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                            : _createCommentVNode("", true)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024))
                                                                            }), 128))
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                                      key: 2,
                                                                      cols: "12"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _hoisted_15
                                                                      ]),
                                                                      _: 1
                                                                    })),
                                                              (_ctx.getApplicationAttributes(app).length)
                                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                                    key: 3,
                                                                    cols: "12"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _hoisted_16,
                                                                      _createVNode(_component_v_row, { class: "ml-2" }, {
                                                                        default: _withCtx(() => [
                                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getApplicationAttributes(app), (attribute) => {
                                                                            return (_openBlock(), _createBlock(_component_v_col, {
                                                                              cols: "12",
                                                                              key: attribute.id
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_row, {
                                                                                  "no-gutters": "",
                                                                                  justify: "space-between"
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_col, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                                          default: _withCtx(() => [
                                                                                            _createTextVNode(_toDisplayString(attribute.name), 1)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1024),
                                                                                        _createVNode(_component_v_list_item_subtitle, null, {
                                                                                          default: _withCtx(() => [
                                                                                            _createTextVNode(_toDisplayString(attribute.description), 1)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1024)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024),
                                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                                      default: _withCtx(() => [
                                                                                        (attribute.type === 'boolean')
                                                                                          ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                              key: 0,
                                                                                              "hide-details": "",
                                                                                              density: "compact",
                                                                                              modelValue: _ctx.attributes[attribute.id],
                                                                                              "onUpdate:modelValue": [
                                                                                                ($event: any) => ((_ctx.attributes[attribute.id]) = $event),
                                                                                                _cache[15] || (_cache[15] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                              ],
                                                                                              color: "primary"
                                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                          : _createCommentVNode("", true)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024))
                                                                          }), 128))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_dialog, {
                                        attach: true,
                                        modelValue: _ctx.showRemoveDialog[app.id],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.showRemoveDialog[app.id]) = $event)
                                      }, {
                                        default: _withCtx(({ isActive }) => [
                                          _createVNode(_component_v_card, { "max-width": "460" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Remove application from user")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Are you sure you want to remove this application from this user? The user will no longer have access to the application. ")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_spacer),
                                                  _createVNode(_component_v_btn, {
                                                    onClick: ($event: any) => (isActive.value = false)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Cancel ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_v_btn, {
                                                    loading: _ctx.loading,
                                                    disabled: _ctx.loading,
                                                    color: "primary",
                                                    onClick: ($event: any) => {_ctx.removeApplication(app); isActive.value = false}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Remove ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["loading", "disabled", "onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsToAdd, (app) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: app.name,
                                        style: {"background-color":"rgba(0,0,0,0.05)"},
                                        rounded: "",
                                        class: "pa-0 mb-4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panels, { "model-value": _ctx.opened }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel, { "bg-color": "rgba(0,0,0,0.05)" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_expansion_panel_title, {
                                                    class: "py-0 px-2",
                                                    static: "",
                                                    "hide-actions": ""
                                                  }, {
                                                    default: _withCtx(({ collapseIcon, expandIcon, expanded }) => [
                                                      _createVNode(_component_v_row, {
                                                        "no-gutters": "",
                                                        justify: "space-between",
                                                        align: "center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, { cols: "1" }, {
                                                            default: _withCtx(() => [
                                                              expanded
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                                    _createVNode(_component_v_icon, null, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(collapseIcon), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                                    _createVNode(_component_v_icon, null, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(expandIcon), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]))
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_col, { cols: "10" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(app.name), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(app.description), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_col, { cols: "1" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_list_item_action, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_btn, {
                                                                    icon: "",
                                                                    variant: "plain",
                                                                    color: "primary",
                                                                    size: "small",
                                                                    onClick: ($event: any) => (_ctx.removeNewApplication(app))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, {
                                                                        icon: "mdi-delete",
                                                                        size: "large"
                                                                      })
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["onClick"])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_expansion_panel_text, { class: "mt-1" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, null, {
                                                        default: _withCtx(() => [
                                                          (_ctx.getApplicationRoles(app).length)
                                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                                key: 0,
                                                                cols: "12"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_19,
                                                                  _createVNode(_component_v_row, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_select, {
                                                                        class: "mx-2",
                                                                        label: "Application role",
                                                                        items: _ctx.getApplicationRoles(app),
                                                                        modelValue: _ctx.selectedAppRole[app.id],
                                                                        "onUpdate:modelValue": [($event: any) => ((_ctx.selectedAppRole[app.id]) = $event), ($event: any) => {_ctx.appConfigDirtied = true; _ctx.applicationRoleForUser[app.id] = _ctx.selectedAppRole[app.id].id; _ctx.applicationRoleContextForUser[app.id] = null; _ctx.selectedAppRoleContext[app.id] = {}; _ctx.getRoleLookupData(app, _ctx.applicationRoleForUser[app.id]);}],
                                                                        density: "comfortable",
                                                                        "hide-details": "",
                                                                        "item-props": _ctx.roleProps
                                                                      }, {
                                                                        selection: _withCtx(({ item }) => [
                                                                          _createElementVNode("span", _hoisted_20, _toDisplayString(item.value.name), 1)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["items", "modelValue", "onUpdate:modelValue", "item-props"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  (_ctx.applicationRolesLookupData[app.id]?.[_ctx.applicationRoleForUser[app.id]])
                                                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_select, {
                                                                            class: "mx-2",
                                                                            label: _ctx.applicationRolesLookupData[app.id][_ctx.applicationRoleForUser[app.id]].label,
                                                                            items: _ctx.applicationRolesLookupData[app.id][_ctx.applicationRoleForUser[app.id]].items,
                                                                            modelValue: _ctx.selectedAppRoleContext[app.id],
                                                                            "onUpdate:modelValue": [($event: any) => ((_ctx.selectedAppRoleContext[app.id]) = $event), ($event: any) => {_ctx.appConfigDirtied = true; _ctx.applicationRoleContextForUser[app.id] = _ctx.selectedAppRoleContext[app.id].id;}],
                                                                            density: "comfortable",
                                                                            "hide-details": "",
                                                                            "item-props": _ctx.roleContextProps,
                                                                            loading: _ctx.roleLookupDataLoading
                                                                          }, {
                                                                            selection: _withCtx(({ item }) => [
                                                                              _createElementVNode("span", _hoisted_21, _toDisplayString(item.value.name), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["label", "items", "modelValue", "onUpdate:modelValue", "item-props", "loading"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : (app.type === 'hybrid')
                                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 1,
                                                                  cols: "12"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_row, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_col, { cols: "12" }, {
                                                                          default: _withCtx(() => [
                                                                            _hoisted_22
                                                                          ]),
                                                                          _: 1
                                                                        }),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((app as any).subApplications, (ha) => {
                                                                          return (_openBlock(), _createBlock(_component_v_col, {
                                                                            cols: "12",
                                                                            key: ha.id
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_row, {
                                                                                "no-gutters": "",
                                                                                justify: "space-between",
                                                                                align: "center"
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_col, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_v_list_item_title, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode(_toDisplayString(app?.details?.applications?.find((a) => a.applicationId === ha.id)?.tabName || ha.name), 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024),
                                                                                      _createVNode(_component_v_list_item_subtitle, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode("Enabled for this user")
                                                                                        ]),
                                                                                        _: 1
                                                                                      })
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024),
                                                                                  _createVNode(_component_v_col, { cols: "2" }, {
                                                                                    default: _withCtx(() => [
                                                                                      ha
                                                                                        ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                            key: 0,
                                                                                            "hide-details": "",
                                                                                            density: "compact",
                                                                                            modelValue: ha.enabled,
                                                                                            "onUpdate:modelValue": [
                                                                                              ($event: any) => ((ha.enabled) = $event),
                                                                                              _cache[16] || (_cache[16] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                            ],
                                                                                            color: "primary"
                                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                        : _createCommentVNode("", true)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 2,
                                                                  cols: "12"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode("This application does not have any roles")
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })),
                                                          (_ctx.getApplicationAttributes(app).length)
                                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                                key: 3,
                                                                cols: "12"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_23,
                                                                  _createVNode(_component_v_row, { class: "ml-2" }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getApplicationAttributes(app), (attribute) => {
                                                                        return (_openBlock(), _createBlock(_component_v_col, {
                                                                          cols: "12",
                                                                          key: attribute.id
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_row, {
                                                                              "no-gutters": "",
                                                                              justify: "space-between"
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_col, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(attribute.name), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024),
                                                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(attribute.description), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024),
                                                                                _createVNode(_component_v_col, { cols: "2" }, {
                                                                                  default: _withCtx(() => [
                                                                                    (attribute.type === 'boolean')
                                                                                      ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                          key: 0,
                                                                                          "hide-details": "",
                                                                                          density: "compact",
                                                                                          modelValue: _ctx.attributes[attribute.id],
                                                                                          "onUpdate:modelValue": [
                                                                                            ($event: any) => ((_ctx.attributes[attribute.id]) = $event),
                                                                                            _cache[17] || (_cache[17] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                          ],
                                                                                          color: "primary"
                                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                      : _createCommentVNode("", true)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["model-value"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newApps, (app) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        class: "mb-1 px-0 pt-0",
                                        key: app.name
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_combobox, {
                                            class: "app-combobox",
                                            clearable: "",
                                            items: _ctx.filteredTenantApplications,
                                            "item-title": "name",
                                            "hide-details": "",
                                            density: "comfortable",
                                            disabled: !_ctx.filteredTenantApplications.length,
                                            placeholder: `${_ctx.filteredTenantApplications.length ? 'Search applications to assign to this user' : 'There are no more applications to assign to this user'}`,
                                            "return-object": "",
                                            "menu-props": { maxWidth: 452 }
                                          }, {
                                            selection: _withCtx(({ item }) => [
                                              _createElementVNode("div", _hoisted_24, [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ]),
                                            item: _withCtx(({ item }) => [
                                              _createElementVNode("div", _hoisted_25, [
                                                _createVNode(_component_v_list_item, {
                                                  onClick: async () => { _ctx.newApp = item.raw; await _ctx.addApplicationAccess() }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["items", "disabled", "placeholder"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.loading || !_ctx.appConfigDirtied || !_ctx.hasRoleAssigned(),
                  color: "primary",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.saveUser(); _ctx.appConfigDirtied = false;})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save user ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}